import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { useLayoutEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'
import aa from 'search-insights'
import {
  ensureAlgoliaSubscribed,
  useHasMarketingConsent,
} from 'src/sdk/analytics/hooks/useUserToken'
import { ALGOLIA_COOKIE_DURATION } from './searchbarQueries'

const hasAlgoliaCookie = () =>
  document.cookie.split(';').some((c) => c.trim().startsWith('_ALGOLIA='))

const InsightsConsentEnabler = () => {
  const { addMiddlewares } = useInstantSearch()
  const hasConsent = useHasMarketingConsent()

  useLayoutEffect(() => {
    if (!hasConsent) return

    aa('init', {
      apiKey: process.env.GATSBY_ALGOLIA_API_KEY ?? '',
      appId: process.env.GATSBY_ALGOLIA_APP_ID ?? '',
      useCookie: true,
      userHasOptedOut: false,
      cookieDuration: ALGOLIA_COOKIE_DURATION,
    })

    // rete di sicurezza: probabilmente ridondante, da verificare
    if (!hasAlgoliaCookie()) (aa as any)('setAnonymousUserToken')

    window.aa = aa
    ensureAlgoliaSubscribed()

    const remove = addMiddlewares(
      createInsightsMiddleware({ insightsClient: aa })
    )

    return remove
  }, [hasConsent, addMiddlewares])

  return null
}

export default InsightsConsentEnabler
